import {useTranslation} from "react-i18next";
import {useState} from "react";
import {json} from "react-router-dom";
import {generateLearningLinks} from "../api/sendTestmailClient";
import LearningLinksDialog from "../components/Template/TemplateTableDialog/LearningLinksDialog";
import {useTestmailDialog} from "./useTestmailDialog";
import {Language} from "../model/Language";

export function useLearningLinkDialog(): [JSX.Element, JSX.Element, (templateIds: string[]) => void, boolean] {
    const {t} = useTranslation();
    const [languageDialog, openLanguageDialog] = useTestmailDialog();

    const [learningLinks, setLearningLinks] = useState<string[]>([]);
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState<boolean>(false);

    const generateLinks = (templateIds: string[], language: Language) => {
        setLoading(true);
        generateLearningLinks(templateIds, language)
            .then((res) => {
                if (!res.ok) {
                    throw json({message: `${t('templateTable.generateLinksError')}`}, {status: 500});
                }
                setLoading(false);
                return res.json()
            })
            .then((data) => {
                setLearningLinks(data);
                setLoading(false);
                setOpen(true);
            })
            .catch((exception) => {
                setLoading(false)
                console.log(exception.message);
            });
    }

    const openDialog = (selectedTemplateIds: string[]) => {
        openLanguageDialog(
            t('templateTable.selectLanguage'),
            "",
            (language: Language) => generateLinks(selectedTemplateIds, language)
        );
    }

    const handleClose = () => {
        setOpen(false)
    }

    const dialog = <LearningLinksDialog
        open={open}
        onClose={handleClose}
        learningLinks={learningLinks}
        loading={loading}
    />

    return [dialog, languageDialog, openDialog, loading]
}